<template>
    <div>
        <page-header>
            <div class="flex flex-col">
                FTP Pull Runs
                <p class="mt-1 text-base font-normal">View history of FTP pull runs and imported files.</p>
            </div>
        </page-header>

        <page-loading v-if="status === 'loading'" />

        <vx-box
            v-else-if="status === 'not_available'"
            color="info"
            class="flex flex-col px-8 py-20 gap-6 items-center text-xl text-slate-500"
        >
            The FTP Pull integration is not available for your team. Please contact Voxie Support if you need access to
            this feature.
        </vx-box>

        <div v-else-if="status === 'connected'">
            <ftp-pull-runs-list />
        </div>

        <vx-box v-else color="info" class="flex flex-col px-8 py-20 gap-6 items-center text-xl text-slate-500">
            <p class="text-center">
                FTP Pull integration is not configured yet. Please configure it first in the
                <a href="/settings/integrations#/ftp-pull" class="text-blue-600 hover:text-blue-800 underline"
                    >FTP Pull</a
                >
                integration settings.
            </p>
        </vx-box>
    </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import { useToasted } from '~/composables/useToasted';
import teamsClient from '~/services/teamsClient';
import FtpPullRunsList from './ftp-pull/FtpPullRunsList.vue';
import PageHeader from '~/components/general/PageHeader.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import { VxBox } from '@voxie/frontend-components';
import type { FtpPullStatusResponse } from '~/types/ftp-pull.types';
import { catchRequestError } from '~/utils/request';

const toasted = useToasted();

const status = ref<FtpPullStatusResponse['status']>('loading');

const loadStatus = async () => {
    try {
        const response = await teamsClient.getFtpPullStatus(Spark.state.currentTeam.id);
        status.value = response.data.status;
    } catch (error) {
        toasted.error(catchRequestError(error));
    }
};

onMounted(() => {
    loadStatus();
});
</script>
